import script from "./SocialLinksForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialLinksForm.vue?vue&type=script&setup=true&lang=js"

import "./SocialLinksForm.vue?vue&type=style&index=0&id=73f39721&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73f39721"]])

export default __exports__